import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('statVenditaCommerciale');
export const actions = helper.createActions('statVenditaCommerciale', actionTypes);